import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-store-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50">
                洞洞杂货铺
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              36漫画网旗下在线免费漫画阅读平台，界面简洁、操作便捷，开启您的沉浸式追漫之旅。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                首页
              </Link>
              <Link to="/category/rexue" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                分类浏览
              </Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              热门分类
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/rexue" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                热血漫画
              </Link>
              <Link to="/category/lianai" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                恋爱漫画
              </Link>
              <Link to="/category/qihuan" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                奇幻漫画
              </Link>
              <Link to="/category/xuanyi" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                悬疑漫画
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-2.5 text-sm text-background-400">
              <p>邮箱：contact@36manhua.com</p>
              <p>客服QQ：1234567890</p>
              <p>工作时间：周一至周五 9:00-18:00</p>
            </div>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 36漫画网 - 洞洞杂货铺漫画 版权所有 | 备案号：京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}